




























































































































/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import { Managers, User, userIs, UserRole, userRoles } from '@/types/Users'
import { exists, emailRules, currency } from '@/util/inputValidation'
import PhoneInput from '@/components/inputs/PhoneInput.vue'
import CurrencyInput from '@/components/inputs/CurrencyInput.vue'
import { addManager, loadManagers, updateContractor } from '@/services/users'
import { showToast } from '@/services/app'
import { deepCopy } from '@/util/helpers'

@Component({
  components: {
    PhoneInput,
    CurrencyInput,
  },
})
export default class EditUserDialog extends Vue {
  @Prop({ default: false }) readonly opened!: boolean
  @Prop(Object) readonly user: User | undefined

  isValid = false
  loading = false
  type: 'manager' | 'contractor' | null = null
  editMode = false
  editedUser: any = {}
  managerRoles = userRoles.filter(r => r.name.includes('manager'))

  rules = {
    firstName: [exists('First name required')],
    lastName: [exists('Last name required')],
    email: emailRules,
    currency: [(value: string) => !!value || 'Wage required', currency],
    directManager: [(value: string) => !!value || 'Direct manager required'],
    // TODO: Add rule for user roles
    // roles: [(roles: any) => !!roles.length || 'Must select a role']
  }

  userRoles = Object.keys(UserRole)

  @Watch('opened')
  onOpened(opened: boolean) {
    if (!opened) return
    if (!this.editMode) (this.$refs.form as HTMLFormElement)?.reset()

    loadManagers(this.$store)
    
    if (this.user) {
      this.editMode = true
      this.editedUser = deepCopy(this.user)
      // this.editedUser = {
      //   ...this.user,
      // }
    }
    else {
      Vue.set(this.editedUser, 'roles', [
        {
          id: UserRole.Supervisor,
          name: 'contractor_manager',
        },
      ])
    }
  }

  mounted() {
    this.editedUser.manager_id = this.me?.id
  }

  get me() {
    return this.$store.getters.me
  }

  get managers() {
    return this.$store.state.users.managers
  }

  get userIsContractor() {
    return userIs(this.editedUser, UserRole.Contractor)
  }

  get userIsManager() {
    return userIs(this.editedUser, ...Managers)
  }

  closeDialog() {
    this.$emit('update:opened', false)
  }

  async addUser() {
    this.loading = true
    try {
      if (this.editMode) {
        if (this.userIsManager) {
          // updateManager()
        }

        if (this.userIsContractor) {
          await updateContractor(
            this.$store,
            {
              ...this.editedUser.contractor_info,
              direct_manager: this.editedUser.manager_id
            },
            this.editedUser.id,
          )
        }
      } else {
        if (this.userIsManager) {
          await addManager(this.$store, this.editedUser)
        }
      }

      showToast(this.$store, {
        text: `
          ${this.editedUser.first_name}
          ${this.editedUser.last_name}
          ${this.editMode ? 'updated' : 'added'}
        `,
      })
      this.closeDialog()
    } finally {
      this.loading = false
    }
  }
}
